import { InfoToFetchActivityData } from '@/controllers/Activity';
import { ChangeStageInfo, OpportunityController } from '@/controllers/Opportunity';
import { AssignSalesRepresentativeVm, ReduxAction, ReduxSagaAction } from '@/types';

import { OpportunitiesActionTypes } from './action-types';

export const changeStage = (
  changeStageInfo: ChangeStageInfo,
  activityData?: InfoToFetchActivityData,
  openSubmitModalOnSuccess = false,
): ReduxAction => ({
  type: OpportunitiesActionTypes.CHANGE_STAGE.START,
  payload: { changeStageInfo, activityData, openSubmitModalOnSuccess },
});

export const clearChangeStateError = (): ReduxAction => ({
  type: OpportunitiesActionTypes.CHANGE_STAGE.CLEAN_UP,
});

export const fetchOpportunities = (): ReduxSagaAction => ({
  type: OpportunitiesActionTypes.FETCH_OPPORTUNITIES.START,
  subtypes: OpportunitiesActionTypes.FETCH_OPPORTUNITIES,
  promise: OpportunityController.fetchOpportunities,
});

export const fetchOpportunity = (id: string): ReduxSagaAction => ({
  type: OpportunitiesActionTypes.FETCH_OPPORTUNITY.START,
  subtypes: OpportunitiesActionTypes.FETCH_OPPORTUNITY,
  promise: () => OpportunityController.fetchOpportunity(id),
});

export const clearOpportunity = (): ReduxAction => ({
  type: OpportunitiesActionTypes.FETCH_OPPORTUNITY.CLEAN_UP,
});

export const assignSalesRepresentative = (payload: AssignSalesRepresentativeVm) => ({
  type: OpportunitiesActionTypes.ASSIGN_SALES_REPRESENTATIVE.START,
  payload,
});
